export default __webpack_public_path__ + "static/media/ppt.2b044d27.svg";